"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSettingsComponent = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_select_1 = require("../../components/input/input.select");
const input_state_group_1 = require("../../components/input/input.state.group");
const mithril_component_1 = require("../../components/mithril.component");
const modal_service_1 = require("../../components/modal/modal.service");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const user_settings_service_1 = require("../../services/user.settings.service");
const CSS = {
    error: 'c-Settings__error',
    saved: 'c-Settings__saved'
};
(0, theme_1.addStyles)({
    [CSS.saved]: {
        color: '',
        'padding-left': theme_1.DefaultTheme.space(2),
        height: theme_1.DefaultTheme.space(6)
    }
});
class ChangeSettingsComponent extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super();
        this.changingSettings = false;
        this.dateFormat = new input_select_1.SelectInputState(i18n_1.T.SETTINGS_DATE_FORMAT);
        this.units = new input_select_1.SelectInputState(i18n_1.T.SETTINGS_UNITS);
        this.form = new input_state_group_1.IkeInputStateGroup();
        this.form.add(this.units);
        this.form.add(this.dateFormat);
        user_settings_service_1.UNIT_OPTIONS.forEach(unit => this.units.addOption({ key: (0, i18n_1.Translate)(unit.label), value: unit.unit }));
        user_settings_service_1.DATE_OPTIONS.forEach(dateFormat => this.dateFormat.addOption({ key: dateFormat, value: dateFormat }));
    }
    get nodes() {
        return [
            input_select_1.SelectInputComponent.view(this.dateFormat),
            input_select_1.SelectInputComponent.view(this.units)
        ];
    }
    viewActions() {
        const submitChildren = this.changingSettings ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.SETTINGS_DONE);
        return (0, mithril_1.m)('button', { className: 'mdl-button', disabled: this.changingSettings, type: 'submit' }, submitChildren);
    }
    reset() {
        this.changingSettings = false;
        this.form.reset();
        this.units.setValue(services_1.Services.UserSettings.units);
        this.dateFormat.setValue(services_1.Services.UserSettings.dateFormat);
    }
    open() {
        this.reset();
        this.autorun(_ => this.updateSettings());
        modal_service_1.ModalService.open({
            title: i18n_1.T.SETTINGS_TITLE,
            content: _ => this.view(),
            actions: _ => this.viewActions(),
            onSubmit: _ => this.close()
        });
    }
    setDone(e) {
        this.changingSettings = false;
        this.reset();
        if (e) {
            notification_service_1.NotificationService.error({ key: i18n_1.T.SETTINGS_ERROR_SAVING });
        }
        else {
            notification_service_1.NotificationService.success({ key: i18n_1.T.SETTINGS_SAVED });
        }
    }
    watchProgress(promise) {
        this.form.setDisabled(true);
        this.changingSettings = true;
        promise
            .then(_ => this.setDone())
            .catch(e => this.setDone(e));
    }
    updateSettings() {
        var currentUnits = this.units.value;
        var currentDateFormat = this.dateFormat.value;
        if (currentUnits !== services_1.Services.UserSettings.units) {
            this.watchProgress(services_1.Services.UserSettings.setUnits(currentUnits));
            return true;
        }
        if (currentDateFormat !== services_1.Services.UserSettings.dateFormat) {
            this.watchProgress(services_1.Services.UserSettings.setDateFormat(currentDateFormat));
            return true;
        }
        return false;
    }
    close() {
        if (modal_service_1.ModalService.isOpen) {
            modal_service_1.ModalService.close(false);
        }
        this.reset();
    }
}
exports.ChangeSettingsComponent = ChangeSettingsComponent;
tslib_1.__decorate([
    mobx_1.observable
], ChangeSettingsComponent.prototype, "changingSettings", void 0);
tslib_1.__decorate([
    mobx_1.action
], ChangeSettingsComponent.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], ChangeSettingsComponent.prototype, "open", null);
tslib_1.__decorate([
    mobx_1.action
], ChangeSettingsComponent.prototype, "setDone", null);
tslib_1.__decorate([
    mobx_1.action
], ChangeSettingsComponent.prototype, "watchProgress", null);
tslib_1.__decorate([
    mobx_1.action
], ChangeSettingsComponent.prototype, "close", null);
//# sourceMappingURL=change.settings.js.map